"use client";

// Components for page logic
import { ToastContainer } from "react-toastify";

// Components for page body
import Header from "@/components/header";
import Footer from "@/components/footer";
import Main from "@/app/core";
import Changelog from "@/components/changelog";

export default function MTMTScoring() {
  return (
    <div className="flex flex-col min-h-screen bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-red-100 via-gray-100 to-gray-200 animate-gradient-xy">
      <Header
        name="MTMTScoring"
        desc="Éves MTMT publikációk konvertálása Excel formátumba"
        link="https://kozlekedes.bme.hu"
      />
      <Changelog />
      <div className="flex-grow">
        <Main/>
      </div>
      <ToastContainer />
      <Footer />
    </div>
  );
}
